import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnexoRepository } from '@app/data/anexo/anexo.repository';
import { MedicaoRepository } from '@app/data/medicoes/medicao.repository';
import { modal } from '@app/shared/alerts/modal/modal.alert';
import { FileData } from '@app/shared/components/anexos/file/file.component';
import { AnexosComponent, AnexosOptions } from '@components/anexos/anexos.component';
import { Campo, FormComponent } from '@components/form/form.component';

@Component({
  selector: 'app-reprovar-medicao',
  templateUrl: './reprovar-medicao.component.html',
  styleUrls: ['./reprovar-medicao.component.scss'],
})
export class ReprovarMedicaoComponent implements AfterContentChecked {
  protected loading: boolean = false;

  protected anexosOptions: AnexosOptions = {
    disableUpload: false,
  };

  justificativaControl = new FormControl(null, [Validators.required]);

  @ViewChild('formDetalhes') formDetalhes: FormComponent | undefined;
  @ViewChild('anexos') anexos: AnexosComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ReprovarMedicaoComponent>,
    private changeDetector: ChangeDetectorRef,
    private anexoRepository: AnexoRepository,
  ) {}

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngOnInit(): void {
    this.anexoRepository.getAnexos('Medicoes', this.data.codigoMedicao).subscribe((data: any) => {
      if (this.anexos) {
        this.anexos.setSentFiles(data);
      }
    });
  }

  protected onClose() {
    this.dialogRef.close(null);
  }

  protected onSubmit(anexos: FileData[]) {
    if (anexos.length > 0) {
      this.anexoRepository.postAnexos('Medicoes', this.data.codigoMedicao, anexos).subscribe({
        next: () => {
          this.dialogRef.close(this.justificativaControl.value);
        },
        error: () => {
          modal.fire({
            icon: 'error',
            title: 'Erro ao salvar anexos',
            html: 'Tente novamente mais tarde por meio dos detalhes das medições',
          });

          this.dialogRef.close(this.justificativaControl.value);
        },
      });
    } else {
      this.dialogRef.close(this.justificativaControl.value);
    }
  }
}
